import moment from "moment";
import React from "react";
import {
  getStartingCalendarDayAdjustment,
  getWeekColumnData,
  invertColor,
} from "../../../../../utils/annual-planner-helpers";

export const EventCounter = ({
  month,
  startingCalendarDay,
  numberOfWeeks,
  calendarEvents,
}) => {
  return (
    <div className="event-counters-wrapper">
      {calendarEvents.map((event, index) => (
        // For each event we map a row containing the bubbles that count the remaining weeks until the event
        <div
          className="event-counter-row"
          key={`event-counter-row-${index}-${Math.random()
            .toString(16)
            .slice(2)}`}
        >
          {Array.from(Array(numberOfWeeks).keys(), (weekNumber, index) => {
            const weekFirstDay = getWeekColumnData(
              month,
              startingCalendarDay,
              weekNumber
            );

            const eventDate = moment(event.fromDate, "YYYYMMDD");

            const adjustmentAmount = getStartingCalendarDayAdjustment(
              moment(event.fromDate, "YYYYMMDD"),
              startingCalendarDay
            );

            const weekDifference = moment(eventDate).diff(
              moment(weekFirstDay),
              "weeks"
            );

            const upcomingWeek = moment(weekFirstDay).isAfter(moment.utc());

            // Returning the count-bubble with the week difference amout (until the event)
            return (
              <EventWeekNumber
                key={`event-week-number-${index}`}
                weekDifference={weekDifference}
                upcomingWeek={upcomingWeek}
                eventColor={event.eventColor}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

const EventWeekNumber = ({ weekDifference, upcomingWeek, eventColor }) => {
  const contrastColor = invertColor(eventColor);

  if (weekDifference < 1)
    return <div className={`event-counter-item hidden`}>{weekDifference}</div>;

  if (upcomingWeek)
    return (
      <div
        style={{ backgroundColor: eventColor, color: contrastColor }}
        className={`event-counter-item${weekDifference < 1 ? " hidden" : ""}`}
      >
        {weekDifference}
      </div>
    );
  return (
    <div className={`event-counter-item${weekDifference < 1 ? " hidden" : ""}`}>
      {weekDifference}
    </div>
  );
};
